export function getAccessibleCompanyPages(user) {
  const pages = Array.isArray(user?.pages) ? user.pages : [];
  // The backend returns `false` for soft-deleted/orphan memberships; drop those
  // so they can't inflate the switcher count or break id→name resolution.
  return pages.filter((page) => page && page.id != null);
}

export function shouldShowCompanyPageSwitcher(user) {
  return getAccessibleCompanyPages(user).length >= 2;
}

export function findAccessibleCompanyPage(user, pageId) {
  return getAccessibleCompanyPages(user).find((page) => page.id == pageId);
}
